module.exports = __webpack_public_path__ + "static/media/send.eda6cc29.svg";